import { render, staticRenderFns } from "./RaUpgrade.vue?vue&type=template&id=20e5f9b8&scoped=true&"
import script from "./RaUpgrade.vue?vue&type=script&lang=js&"
export * from "./RaUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./RaUpgrade.vue?vue&type=style&index=0&id=20e5f9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5f9b8",
  null
  
)

export default component.exports